import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="brand-footer">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center gap-5 px-4 py-12 text-center sm:px-6 lg:px-8">
        <img
          src="/brand/logo-white.png"
          alt="Tu Iglesia App - Tu aliado en el Ministerio de Cristo"
          className="h-24 w-auto"
        />
        <p className="font-serif text-lg font-bold text-white">Centro de Fortaleza Espiritual</p>
        <p className="max-w-md text-sm text-white/85">
          “Dios es nuestro amparo y fortaleza, nuestro pronto auxilio en las tribulaciones.” — Salmos 46:1
        </p>
        <nav className="flex flex-wrap justify-center gap-4 text-sm text-white/85">
          <Link to="/" className="transition-colors duration-200 hover:text-white" data-testid="footer-inicio-link">Inicio</Link>
          <Link to="/archivo" className="transition-colors duration-200 hover:text-white" data-testid="footer-archivo-link">Archivo</Link>
          <Link to="/oracion" className="transition-colors duration-200 hover:text-white" data-testid="footer-oracion-link">Muro de Oración</Link>
        </nav>
        <p className="text-xs text-white/70">
          Tu Iglesia App — Tu aliado en el Ministerio de Cristo. Hecho con amor para Venezuela.
        </p>
      </div>
    </footer>
  );
}
